import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function DocClassifier() {
  const [cardData, setCardData] = useState("");
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData("");
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://4a5pkdbf1k.execute-api.ap-south-1.amazonaws.com/default/Document_Classifier",
      headers: {
        "x-api-key": "LvGGcPwIG967MICJ11g25alqXaVfosjd7Y3eO8r2",
        authorizationToken: "8cbFVT2xMG8cJqv3",
        
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div class="container containerBoreder " >
        <h2 class="pageTitle">Document Classifier</h2>
        <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th width="25%">Document Name </th>
              <td>{cardData.Document_Name}</td>
            </tr>
          </tbody>
        </table>
    
      </div>
    </div>
  );
}

export default DocClassifier;
